import React from "react";

export default function QuizOption({
  option,
  optionId,
  question,
  handleOptionSelected,
  quizId,
}) {
  const idFromQuestion = question.split(" ").join("") + optionId;
  return (
    <label htmlFor={idFromQuestion}>
      <input
        type="checkbox"
        onChange={() => handleOptionSelected(quizId, optionId)}
        id={idFromQuestion}
      />
      {option.option}
    </label>
  );
}
